import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const textDecoration = system({
    textDecoration: true,
});

export interface TextDecorationProps<ThemeType extends Theme = RequiredTheme> {
    textDecoration?: ResponsiveValue<CSS.Property.TextDecoration, ThemeType> | undefined;
}
